module.exports = __webpack_public_path__ + "img/CV.Utilities.Potable_water.HDPE_pipe.d94f8a40.png";